var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "url(#paint0_linear_597_35221)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1517 20.8485C24.7915 20.8485 26.9295 18.7105 26.9295 16.0707C26.9295 13.431 24.7915 11.293 22.1517 11.293C19.512 11.293 17.374 13.431 17.374 16.0707C17.374 18.7105 19.512 20.8485 22.1517 20.8485ZM22.1517 23.2374C18.9626 23.2374 12.5962 24.838 12.5962 28.0152V29.2096C12.5962 29.8666 13.1337 30.4041 13.7906 30.4041H30.5129C31.1698 30.4041 31.7073 29.8666 31.7073 29.2096V28.0152C31.7073 24.838 25.3409 23.2374 22.1517 23.2374Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_35221",
    x1: 0,
    y1: 21.5,
    x2: 43,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA085"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.7743b7feb134fb0fb5576d24a9f0ee8e.svg";
export { ForwardRef as ReactComponent };